module.exports = __webpack_public_path__ + "static/media/no_significance.6892006e.svg";